var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',[_c('VerificaIscrizione',{attrs:{"data":_vm.data}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }